import React from "react";
import map from "lodash/map";
import { connect } from "react-redux";

import { getCFschema } from "../../api/requests";

import classes from "./SettingsConsentForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import moment from "moment-timezone";
import FormBuilderCustomView from "../../containers/FormBuilder/FormBuilderCustomView";
import { Controlled as CodeMirror } from "react-codemirror2";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class SettingsConsentFormBuilderPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      schema: null,
    };

    this.quillRef = React.createRef();
  }

  async componentDidMount() {
    const { data } = await getCFschema(this.props.url);
    this.setState({ schema: data });

    if (this.editorInstance) {
      this.editorInstance.setSize("100%", "500px");
    }
  }

  render() {
    const { schema } = this.state;
    const { isJsonRaw } = this.props;

    return (
      <div className={classes.wrapper}>
        {isJsonRaw && schema && (
          <CodeMirror
            editorDidMount={(editor) => {
              this.editorInstance = editor;
            }}
            value={JSON.stringify(schema, null, 4)}
            options={{
              indentWithTabs: false,
              theme: "material",
              mode: "application/ld+json",
              lineNumbers: true,
              lineWrapping: true,
              foldGutter: true,
              gutters: [
                "CodeMirror-linenumbers",
                "CodeMirror-foldgutter",
                "CodeMirror-lint-markers",
              ],
              autoCloseBrackets: true,
              matchBrackets: true,
              lint: true,
              readOnly: true,
            }}
          />
        )}

        {!isJsonRaw && (
          <div>
            {schema && (
              <div>
                {Array.isArray(schema) ? (
                  <div>
                    {map(schema, (item) =>
                      map(Object.keys(item), (key) => (
                        <div>
                          <FormBuilderCustomView
                            isEditable
                            disabledSave
                            name={key.replace(/_/g, ' ')}
                            schema={item[key]}
                          />
                          <br />
                          <hr />
                          <br />
                        </div>
                      ))
                    )}
                  </div> /*(
              schema.map((item, i) => (
                <FormBuilderCustomView
                  isEditable
                  name={this.props.name}
                  schema={item}
                  key={i}
                />
              ))
            )*/
                ) : (
                  <FormBuilderCustomView
                    isEditable
                    disabledSave
                    name={this.props.name}
                    schema={schema}
                  />
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(SettingsConsentFormBuilderPreview));



// WEBPACK FOOTER //
// ./src/components/SettingsConsentForm/SettingsConsentFormBuilderPreview.js